module.exports = __webpack_public_path__ + "static/1077-c16c273f79fd44a4f0eb17303e5030d8.png";